import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Description, FixMeta, MetaInformation, TextContainer, Title } from './HeroStageOverlay.styles';
import { WatchProgress } from './WatchProgress';
import SvgAbroad from '../../../../play-core/icons/Abroad';
import { isLivestream } from '../../../../play-core/models/Media';
import { usePlayableAtLocation } from '../../hooks/use-playable-at-location';
import { formatDuration } from '../../utils/duration-formatter';
import { createSeparatedList } from '../../utils/separated-list-helper';
import { DotSeparator } from '../DotSeparator/DotSeparator';
import { IconText } from '../IconText/IconText';
import { InfoLabel } from '../InfoLabel/InfoLabel';
import { getLabel, getLabelMap } from '../InfoLabel/label-helper';
import { PlayContainer } from '../PlayContainer/PlayContainer';
import { useVideoProgress } from '../Teaser/TeaserActions/use-video-progress';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HeroStageOverlay = ({
  media,
  aspectRatio,
  style
}) => {
  const {
    t
  } = useTranslation();
  // only display show name if it is not already included in the title
  const displayShowName = !!media.show?.title && !media.title.toLowerCase().includes(media.show.title.toLowerCase());
  const isPlayableAtLocation = usePlayableAtLocation(media);
  const videoProgress = useVideoProgress(media);
  const label = useMemo(() => getLabel(['live'], getLabelMap(t, media)), [media, t]);
  const list = [media.show && displayShowName && /*#__PURE__*/_jsx("span", {
    children: media?.show?.title
  }), !isLivestream(media) && /*#__PURE__*/_jsx("span", {
    children: formatDuration(media.duration, t)
  }), !isPlayableAtLocation && /*#__PURE__*/_jsx(IconText, {
    icon: /*#__PURE__*/_jsx(SvgAbroad, {}),
    text: t('geoblocking.onlyCH'),
    fontSize: {
      mediaQuery: [],
      default: 'inherit'
    },
    fontType: 'Medium',
    spaceBetween: 2
  })];
  const dotSeparatedList = createSeparatedList(list, /*#__PURE__*/_jsx(DotSeparator, {}));
  return /*#__PURE__*/_jsx(Container, {
    aspectRatio: aspectRatio,
    children: /*#__PURE__*/_jsx(PlayContainer, {
      children: /*#__PURE__*/_jsxs(FixMeta, {
        style: style,
        children: [/*#__PURE__*/_jsxs(TextContainer, {
          children: [label && /*#__PURE__*/_jsx(InfoLabel, {
            type: label?.type,
            text: label?.text
          }), /*#__PURE__*/_jsx(Title, {
            children: media?.title
          }), media?.lead && /*#__PURE__*/_jsx(Description, {
            children: media.lead
          })]
        }), videoProgress > 0 ? /*#__PURE__*/_jsx(WatchProgress, {
          progress: videoProgress,
          duration: media.duration
        }) : dotSeparatedList.length > 0 && /*#__PURE__*/_jsx(MetaInformation, {
          children: dotSeparatedList
        })]
      })
    })
  });
};